module.exports = __webpack_public_path__ + "static/media/lemon-collected.45e208f9.png";